import '../../EmptyState.scss';
import Paragraph from "components/TextComps/Paragraph";
import { useTranslation } from "react-i18next";

export const NoInvitesLeft = () => {
  const { t } = useTranslation();

  return (
    <div className='no-data-found'>
      <h2>{t('NoInvitesLeft', { ns: 'studentsPage' })}</h2>
      <Paragraph>
        <>{t('YouHaveNoInvitesLeft', { ns: 'studentsPage' })}</>
      </Paragraph>
    </div>
  );
};
